/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ManagerTypeResponse } from './';
import {
    ManagerTypeResponseFromJSON,
    ManagerTypeResponseFromJSONTyped,
    ManagerTypeResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateReferralManagerRequest
 */
export interface UpdateReferralManagerRequest {
    /**
     * 
     * @type {ManagerTypeResponse}
     * @memberof UpdateReferralManagerRequest
     */
    managerType: ManagerTypeResponse;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferralManagerRequest
     */
    managerId: string;
}

/**
 * Check if a given object implements the UpdateReferralManagerRequest interface.
 */
export function instanceOfUpdateReferralManagerRequest(value: object): value is UpdateReferralManagerRequest {
    if (!('managerType' in value) || value['managerType'] === undefined) return false;
    if (!('managerId' in value) || value['managerId'] === undefined) return false;
    return true;
}

export function UpdateReferralManagerRequestFromJSON(json: any): UpdateReferralManagerRequest {
    return UpdateReferralManagerRequestFromJSONTyped(json, false);
}

export function UpdateReferralManagerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReferralManagerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'managerType': ManagerTypeResponseFromJSON(json['managerType']),
        'managerId': json['managerId'],
    };
}

export function UpdateReferralManagerRequestToJSON(value?: UpdateReferralManagerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'managerType': ManagerTypeResponseToJSON(value['managerType']),
        'managerId': value['managerId'],
    };
}

